module.exports = __webpack_public_path__ + "img/studentLogo.f0b0fc56.png";